import { useLayoutEffect, useRef } from "react";

export const useResizeObserver = (callback, externalRef, disableObserver=false) => {
  const ref = useRef(null);
  const observer = useRef(null);
  
  useLayoutEffect(() => {
    if(disableObserver) {
      observer.current?.disconnect();
      return;
    }

    const element = externalRef || ref?.current;
    if (!element) return;
    
    observer.current = new ResizeObserver((entries) => {
      callback(element, entries[0]);
    });
    
    observer.current.observe(element);
    
    return () => {
      observer.current?.disconnect();
    };
  }, [ callback, ref, externalRef, disableObserver ]);
  
  return ref;
}